import { render } from "./SignIn2FA.vue?vue&type=template&id=aaf15262&scoped=true"
import script from "./SignIn2FA.vue?vue&type=script&lang=js"
export * from "./SignIn2FA.vue?vue&type=script&lang=js"

import "./SignIn2FA.vue?vue&type=style&index=0&id=aaf15262&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaf15262"]])

export default __exports__